import { motion } from "framer-motion";
import { MaskedLine, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, lines, sub, image, testId }) => (
  <section
    data-testid={testId}
    className="blueprint-grid relative overflow-hidden border-b border-white/10 pt-32 pb-16 sm:pt-44 sm:pb-24"
  >
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/55 via-obsidian/70 to-obsidian" />
        <div className="absolute inset-0 blueprint-grid opacity-70" />
      </div>
    )}
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>{eyebrow}</Eyebrow>
      </motion.div>
      <h1 className="mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-black uppercase leading-[0.95] tracking-tight text-white">
        {lines.map((line, i) => (
          <MaskedLine key={line} delay={0.15 + i * 0.12}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-400"
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
